import{a}from"./chunk-VFKB5IBK.js";import{a as b}from"./chunk-RAAYCPUM.js";function o(...e){return b(c,e)}function c(e,u){for(let[t,y]of Object.entries(u))if(!Object.hasOwn(e,t)||!a(y,e[t]))return!1;return!0}export{o as a};
